<template>
    <v-dialog v-model="showModel" width="500" :persistent="persistent">
        <v-card>
            <v-card-text v-html="message" />

            <v-divider></v-divider>

            <v-card-actions>
                <v-btn color="primary" flat @click="showModel = false">
                    {{ closeButtonText | translation }}
                </v-btn>

                <v-spacer></v-spacer>

                <router-link
                    v-if="buttonText && buttonLink"
                    @click.native="showModel = false"
                    :to="buttonLink"
                    class="btn btn-primary"
                >
                    {{ buttonText }}
                </router-link>
                <v-btn v-else-if="buttonText" @click="onButtonClick" color="primary" flat>
                    {{ buttonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

const moduleName = 'NotificationModal';

export default {
    name: moduleName,
    computed: {
        ...mapState(moduleName, {
            show: state => state.show,
            persistent: state => state.persistent,
            message: state => state.message,
            closeButtonText: state => state.closeButtonText,
            buttonText: state => state.buttonText,
            buttonLink: state => state.buttonLink,
            buttonCallback: state => state.buttonCallback
        }),
        showModel: {
            get(){
                return this.show;
            },
            set(value){
                this.setShow(value);
            },
        },
    },
    methods: {
        ...mapMutations(moduleName, ['setShow']),
        onButtonClick() {
            if (typeof this.buttonCallback == 'function') {
                this.buttonCallback();
            }
        }
    },
};
</script>
